import React from 'react'
import RichText from '@/components/RichText'
import { CMSLink } from '@/components/Link'

export interface StripCTALink {
  link: any
}

export interface StripCTAProps {
  links?: StripCTALink[]
  richText?: any
  className?: string
}

export const StripCTA: React.FC<StripCTAProps> = ({ 
  links, 
  richText,
  className 
}) => {
  return (
    // Full-bleed escape — same trick as HeroSection; needs overflow-x:hidden on body (globals.scss).
    <div className={`overflow-hidden py-[50px] relative left-1/2 -mx-[50vw] w-screen ${className || ''}`}>
      <div className={'-rotate-1 scale-105 shadow-xl'}>
        <div
          className={'h-[40px] w-full -mb-[1px]'}
          style={{
            backgroundImage: `url(/media/film-strip-top-black.png)`,
            backgroundSize: 'contain',
            backgroundRepeat: 'repeat-x',
          }}
        ></div>
        <div className="bg-black flex flex-col justify-center text-white text-center">
          <div className={'container'}>
            <div className={'my-16 flex justify-center text-white'}>
              <div className="flex">
                {richText && (
                  <RichText
                    className="mb-0"
                    content={richText}
                    enableProse={false}
                    enableGutter={false}
                  />
                )}
              </div>
              <div className="flex flex-col gap-8 mt-4">
                {(links || []).map(({ link }, i) => {
                  return <CMSLink key={i} size="lg" {...link} />
                })}
              </div>
            </div>
          </div>
        </div>
        <div
          className={'h-[40px] w-full -mt-[1px]'}
          style={{
            backgroundImage: `url(/media/film-strip-bottom-black.png)`,
            backgroundSize: 'contain',
            backgroundRepeat: 'repeat-x',
          }}
        ></div>
      </div>
    </div>
  )
}